<template>
  <div>
    <!-- MODAL CHOOSE IMAGE -->
    <sweet-modal ref="modal-BlogAuthorCardComponent" width="500px">
      <card-author-settings :config="internal_config" @save="save" @close="close"></card-author-settings>
    </sweet-modal>
    <sweet-modal ref="modal-BlogArticleListComponent" width="1100px">
      <blog-article-settings ref="settings-BlogArticleListComponent"  @save="save" @close="close"></blog-article-settings>
    </sweet-modal>
    <sweet-modal ref="modal-BlogPostComponent" :title="$t('ct-option-blog-post-settings')" width="900px">
      <post-settings  ref="settings-BlogPostComponent" :params="internal_config" @save="save" @close="close"></post-settings>
    </sweet-modal>
  </div>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue';
import CardAuthorSettings from './content/CardAuthorSettings';
import FeaturedSettings from './content/FeaturedSettings';
import PostSettings from './content/PostSettings';
import FeaturedGroupSettings from './content/FeaturedGroupSettings';
import BlogArticleSettings from './content/BlogArticleSettings';

export default {
  name: 'BlogSettingsModal',
  components: {
    SweetModal,
    CardAuthorSettings,
    FeaturedSettings,
    PostSettings,
    FeaturedGroupSettings,
    BlogArticleSettings
  },
  data() {
    return {
      internal_config: false,
      callback: false,
      element: ''
    };
  },
  methods: {
    init(config, callback = false) {
      this.internal_config = config;
      this.callback = callback;
    },
    open(element) {
      this.element = element;

      if (element === 'BlogArticleListComponent') {
        this.$refs[`settings-${element}`].setType(this.internal_config);
      }

      if (element === 'BlogPostComponent') {
        this.$refs[`settings-${element}`].setType(this.internal_config);
      }

      this.$refs[`modal-${element}`].open();
    },
    close() {
      this.$refs[`modal-${this.element}`].close();
    },
    save(data) {
      this.callback(data);
    }
  }
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Settings/Structure.vue